import * as EventAggregator from '@classic/AppUtils/Framework/Messaging/EventAggregator'

export function useEventAggregator() {
  return EventAggregator
}
